import { useState } from 'react'
import './input.css'
import { FaEye, FaEyeSlash } from "react-icons/fa"

function Input({
    styles,
    type,
    text,
    name,
    id,
    placeholder,
    handleOnChange,
    handleOnBlur,
    value,
    multiple,
    rows,
    cols,
    maxlength,
    pattern,
    status,
    step,
    disabled

}) {
    let idName = name
    if(id){
        idName= id
    }

    const [inputType, setInputType] = useState(type || "text")

    if (type !== "textarea") {
        return (

            <div >
                {text &&
                    <label htmlFor={name}>{text}:</label>
                }
                <div className='input-box'>
                    <input className="input" type={type === "password" ? inputType : type} name={name} id={idName} placeholder={placeholder}
                        onChange={handleOnChange}
                        onBlur={handleOnBlur}
                        value={value}
                        {...(step ? step={step}: "") }
                        {...(multiple ? { multiple } : '')}
                        {...(disabled ? { disabled } : '')}


                    />
                    {type === "password" &&
                        (inputType === "password"
                            ?
                            <div className='pwd-eye-box' onClick={() => setInputType("text")}>
                                <FaEyeSlash />
                            </div>
                            :
                            <div className='pwd-eye-box' onClick={() => setInputType("password")}>
                                <FaEye />
                            </div>
                        )
                    }
                </div>
            </div>

        )
    } else {
        return (
            <div>
                {text &&
                    <label htmlFor={name}>{text}:</label>
                }
                <textarea
                    className="input"
                    name={name}
                    id={name}
                    rows={rows ? rows : "3"}
                    cols={cols ? rows : "50"}
                    placeholder={placeholder}
                    onChange={handleOnChange}
                    defaultValue={value}
                    maxlength={maxlength}
                    />

                
            </div>
        )
    }
}
export default Input